var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVhicles = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1617 9.47334V20.4517C24.1617 23.3217 21.8167 25.6667 18.9467 25.6667H9.05338C6.18338 25.6667 3.83838 23.3217 3.83838 20.4517V9.47334C3.83838 7.47834 4.95838 5.74001 6.60338 4.86501C7.17505 4.56167 7.88671 4.97001 7.88671 5.62334C7.88671 7.47834 9.40338 8.99501 11.2584 8.99501H16.7417C18.5967 8.99501 20.1134 7.47834 20.1134 5.62334C20.1134 4.97001 20.8134 4.56167 21.3967 4.86501C23.0417 5.74001 24.1617 7.47834 24.1617 9.47334Z",
    fill: "url(#paint0_linear_640_6480)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7418 2.33334H11.2585C10.0451 2.33334 9.05347 3.31334 9.05347 4.52667V5.62334C9.05347 6.83667 10.0335 7.81667 11.2468 7.81667H16.7418C17.9551 7.81667 18.9351 6.83667 18.9351 5.62334V4.52667C18.9468 3.31334 17.9551 2.33334 16.7418 2.33334Z",
    fill: "url(#paint1_linear_640_6480)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_6480",
    x1: 3.83838,
    y1: 13.647,
    x2: 24.1617,
    y2: 13.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_640_6480",
    x1: 9.05347,
    y1: 4.66375,
    x2: 18.9352,
    y2: 4.66375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVhicles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vhicles.d87a7f0a.svg";
export { ForwardRef as ReactComponent };